import {
  OverlayArrow,
  Tooltip as TooltipAria,
  type TooltipProps as TooltipPropsAria,
  TooltipTrigger,
} from "react-aria-components";
import { tv } from "tailwind-variants";

import { DEFAULT_TOOLTIP_DELAY } from "@/lib/constants/delay";
import { cn } from "@/lib/helpers/cn";

import { Button2, type ButtonProps } from "../atoms/Button";

import "./Tooltip.styles.css";

type TooltipProps = {
  className?: string;
  text: string;
  triggerProps?: ButtonProps;
} & TooltipPropsAria;

export function Tooltip2(props: TooltipProps) {
  const { children, className, text, triggerProps, ...tooltipProps } = props;
  const { tooltip } = tooltipStyles();

  return (
    <TooltipTrigger delay={DEFAULT_TOOLTIP_DELAY}>
      <Button2
        // Bootstrap override. Assume if trigger props are passed tooltip is clickable
        className={cn(!triggerProps && "tw:cursor-help!")}
        rawChildren
        variant="blank"
        {...triggerProps}
      >
        {children}
      </Button2>

      <TooltipAria className={cn(tooltip(), className)} {...tooltipProps}>
        <OverlayArrow className="react-aria-OverlayArrow">
          <svg fill="currentColor" height={6} viewBox="0 0 12 6" width={12}>
            <path d="M0 0 L6 6 L12 0" />
          </svg>
        </OverlayArrow>

        {text}
      </TooltipAria>
    </TooltipTrigger>
  );
}

const tooltipStyles = tv({
  slots: {
    tooltip: cn(
      "react-aria-Tooltip", // aria builtin
      "tw:rounded-sm tw:bg-fill-navy-primary tw:p-2.5 tw:pb-2",
      "tw:text-center tw:text-sm tw:text-text-white tw:outline-none",
      "tw:max-w-[25ch]",
    ),
  },
});
